import { useEffect, useRef, useState } from "react";
import { Reveal } from "@/lib/motion";

const STATS = [
  { value: 38, suffix: "%", label: "Higher win rate" },
  { value: 4.2, suffix: "x", label: "Faster forecasting" },
  { value: 12, suffix: "k+", label: "Deals modeled daily" },
  { value: 99.9, suffix: "%", label: "Uptime SLA" },
];

function Counter({ value, suffix }) {
  const [n, setN] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting && !started.current) {
          started.current = true;
          const dur = 1400;
          const t0 = performance.now();
          const tick = (t) => {
            const p = Math.min(1, (t - t0) / dur);
            const eased = 1 - Math.pow(1 - p, 3);
            setN(value * eased);
            if (p < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        }
      },
      { threshold: 0.4 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [value]);

  const display = Number.isInteger(value) ? Math.round(n) : n.toFixed(1);
  return (
    <span ref={ref}>
      {display}
      <span className="text-acid">{suffix}</span>
    </span>
  );
}

export const Metrics = () => {
  return (
    <section id="metrics" data-testid="metrics-section" className="py-28 md:py-36">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-14 gap-x-8">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08}>
              <div className="border-l border-white/10 pl-5">
                <div className="font-display font-extrabold text-5xl md:text-7xl tracking-tight text-paper">
                  <Counter value={s.value} suffix={s.suffix} />
                </div>
                <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.2em] text-paper/45">
                  {s.label}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
